import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementLocale from 'element-ui/lib/locale'
import elementLangEn from 'element-ui/lib/locale/lang/en'
import elementLangRu from 'element-ui/lib/locale/lang/ru-RU'

import locales from '@/locales'

Vue.use(VueI18n)

// eslint-disable-next-line func-names
VueI18n.prototype.getChoiceIndex = function (choice, choicesLength) {
  if (this.locale !== 'ru') {
    // proceed to the default implementation
    const absChoice = Math.abs(choice)

    if (choicesLength === 2) {
      if (absChoice) {
        if (absChoice > 1) {
          return 1
        }
        return 0
      }
      return 1
    }

    return absChoice ? Math.min(absChoice, 2) : 0
  }

  if (choice === 0) {
    return 0
  }

  const teen = choice > 10 && choice < 20
  const endsWithOne = choice % 10 === 1

  if (!teen && endsWithOne) {
    return 1
  }

  if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
    return 2
  }

  return choicesLength < 4 ? 2 : 3
}

// eslint-disable-next-line func-names
VueI18n.prototype.setLocale = function (locale) {
  this.locale = locale
}

const defaultLocale = 'ru'
const fallbackLocale = 'ru'
const locale = defaultLocale

const i18n = new VueI18n({
  locale,
  fallbackLocale,
  messages: {
    en: {
      ...locales.en,
      ...elementLangEn
    },
    ru: {
      ...locales.ru,
      ...elementLangRu
    }
  }
})

elementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n
